import { useBreakpoint } from "@povio/ui";
import { cx } from "class-variance-authority";
import Skeleton from "react-loading-skeleton";

export const SkeletonWrapper = ({
  className,
  containerClassName,
  children,
}: {
  className?: string;
  containerClassName?: string;
  children?: React.ReactNode;
}) => {
  const isDesktop = useBreakpoint("xl");
  return (
    <div className={cx("relative flex-1", containerClassName)}>
      <Skeleton
        baseColor="#232323"
        highlightColor="#656565"
        containerClassName={cx("flex-1", containerClassName)}
        className={className}
        duration={2}
        borderRadius={isDesktop ? "12px" : "6px"}
      />
      <div className="absolute inset-0">{children}</div>
    </div>
  );
};
